/** English display names for built-in exercise catalog (natural gym wording) */
export const EXERCISE_STANDARD_EN = {
  'exercise.standard.burpee': 'Burpee',
  'exercise.standard.lunges': 'Bodyweight lunges',
  'exercise.standard.bench_press_barbell': 'Barbell bench press',
  'exercise.standard.incline_bench_press_barbell': 'Incline barbell bench press',
  'exercise.standard.decline_bench_press_barbell': 'Decline barbell bench press',
  'exercise.standard.bench_press_dumbbell': 'Dumbbell bench press',
  'exercise.standard.incline_bench_press_dumbbell': 'Incline dumbbell bench press',
  'exercise.standard.overhead_press_barbell': 'Standing barbell overhead press',
  'exercise.standard.push_ups': 'Push-ups',
  'exercise.standard.chest_dips': 'Chest dips',
  'exercise.standard.plank': 'Plank',
  'exercise.standard.pull_ups': 'Pull-ups',
  'exercise.standard.calf_raises_standing': 'Standing calf raises',
  'exercise.standard.squat_bodyweight': 'Bodyweight squats',
  'exercise.standard.squat_barbell': 'Barbell back squat',
  'exercise.standard.lateral_raise_dumbbell': 'Dumbbell lateral raise',
  'exercise.standard.tricep_pushdown': 'Cable triceps pushdown',
  'exercise.standard.barbell_curl': 'Barbell curl',
  'exercise.standard.crunches': 'Crunches',
  'exercise.standard.deadlift': 'Deadlift',
  'exercise.standard.lat_pulldown': 'Lat pulldown',
  'exercise.standard.dumbbell_row': 'Dumbbell row',
  'exercise.standard.chin_up': 'Chin-ups',
  'exercise.standard.lat_pulldown_reverse_grip': 'Reverse-grip lat pulldown',
  'exercise.standard.lat_pulldown_behind_neck': 'Behind-the-neck lat pulldown',
  'exercise.standard.barbell_row_bent_over': 'Bent-over barbell row',
  'exercise.standard.t_bar_row': 'T-bar row',
  'exercise.standard.seated_cable_row': 'Seated cable row',
  'exercise.standard.one_arm_dumbbell_row': 'One-arm dumbbell row',
  'exercise.standard.hyperextension': 'Back extension (hyperextension)',
  'exercise.standard.shoulder_press_dumbbell_seated': 'Seated dumbbell shoulder press',
  'exercise.standard.shoulder_press_barbell_seated': 'Seated barbell overhead press',
  'exercise.standard.arnold_press': 'Arnold press',
  'exercise.standard.shoulder_press_machine': 'Machine shoulder press',
  'exercise.standard.front_raise_dumbbell': 'Dumbbell front raise',
  'exercise.standard.lateral_raise_swing': 'Standing dumbbell lateral raise (momentum)',
  'exercise.standard.rear_delt_fly_bent_over': 'Rear delt fly — bent over',
  'exercise.standard.upright_row_barbell': 'Barbell upright row',
  'exercise.standard.dumbbell_curl_standing': 'Standing dumbbell curl',
  'exercise.standard.dumbbell_curl_seated': 'Seated dumbbell curl',
  'exercise.standard.hammer_curl': 'Hammer curl',
  'exercise.standard.preacher_curl': 'Preacher curl',
  'exercise.standard.cable_curl_seated': 'Seated high-cable curl',
  'exercise.standard.close_grip_bench_press': 'Close-grip bench press',
  'exercise.standard.skull_crusher': 'Skull crusher',
  'exercise.standard.bench_dip': 'Bench dips',
  'exercise.standard.overhead_tricep_extension_dumbbell': 'Overhead dumbbell triceps extension',
  'exercise.standard.pistol_squat': 'Pistol squat',
  'exercise.standard.lunge_dumbbell': 'Dumbbell lunges',
  'exercise.standard.lunge_barbell': 'Barbell lunges',
  'exercise.standard.leg_press': 'Leg press',
  'exercise.standard.hack_squat': 'Hack squat',
  'exercise.standard.squat_smith': 'Smith machine squat',
  'exercise.standard.hack_squat_smith': 'Smith machine hack squat',
  'exercise.standard.romanian_deadlift': 'Romanian deadlift',
  'exercise.standard.stiff_leg_deadlift': 'Stiff-leg deadlift',
  'exercise.standard.calf_raise_seated': 'Seated calf raises',
  'exercise.standard.reverse_crunches': 'Reverse crunches',
  'exercise.standard.hanging_leg_raise': 'Hanging leg raise',
  'exercise.standard.russian_twist': 'Russian twist',
  'exercise.standard.stomach_vacuum': 'Stomach vacuum',
  'exercise.standard.side_plank': 'Side plank',
  'exercise.standard.high_knees': 'High knees',
  'exercise.standard.jump_rope': 'Jump rope',
  'exercise.standard.burpee_jump': 'Burpee with tuck jump',
  'exercise.standard.boxer_shuffle': 'Boxer shuffle',
  'exercise.standard.jump_rope_singles': 'Jump rope — single skips',
  'exercise.standard.sprint': 'Sprint',
  'exercise.standard.stair_climb': 'Stair climbing',
};
